module.exports = __webpack_public_path__ + "static/theclock-7bf7db573111a8f85c84befa8d10a723.webp";